import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Droplets } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DistClientBloodTestsPage = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [clientName, setClientName] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [testsRes, clientsRes] = await Promise.all([
          axios.get(`${API}/blood-tests?client_id=${clientId}`).catch(() => ({ data: [] })),
          axios.get(`${API}/users/clients`),
        ]);
        setTests(Array.isArray(testsRes.data) ? testsRes.data : []);
        const c = clientsRes.data.find(u => u.id === clientId);
        if (c) setClientName(c.name);
      } catch (error) { console.error('Failed to load blood test data:', error); } finally { setLoading(false); }
    };
    fetchData();
  }, [clientId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-12 h-12 rounded-full border-4 border-blue-100 border-t-blue-500 animate-spin" />
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto space-y-5 animate-fade-in pb-4" data-testid="dist-client-blood-tests-page">
      <button onClick={() => navigate(`/distributor/clients/${clientId}`)} className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition-colors" data-testid="back-to-profile">
        <ArrowLeft size={16} /> {clientName || 'Perfil'}
      </button>
      <div className="pt-1">
        <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>Analiticas de Sangre</h1>
        <p className="text-sm text-gray-400 mt-1 font-medium">Resultados de laboratorio de {clientName}</p>
      </div>
      {tests.length === 0 ? (
        <div className="bg-white rounded-3xl border border-gray-100/50 shadow-sm p-10 text-center" data-testid="no-blood-tests">
          <div className="w-20 h-20 bg-gradient-to-br from-blue-50 to-sky-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Droplets size={32} className="text-blue-300" />
          </div>
          <p className="font-bold text-gray-700 text-lg" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>Sin analiticas</p>
          <p className="text-sm text-gray-400 mt-1">Este cliente aun no tiene resultados de laboratorio</p>
        </div>
      ) : (
        <div className="space-y-3">
          {tests.map((test, idx) => (
            <div key={test.id || idx} className="bg-white rounded-2xl border border-gray-100/50 overflow-hidden shadow-sm" data-testid={`blood-test-${test.id || idx}`}>
              <div className="h-1 bg-gradient-to-r from-blue-400 to-sky-500" />
              <div className="p-4">
                <p className="font-bold text-gray-900 text-sm">{test.name || 'Analitica de Sangre'}</p>
                {test.lab_name && <p className="text-xs text-gray-500 mt-0.5">{test.lab_name}</p>}
                {test.created_at && (
                  <p className="text-xs text-gray-400 mt-1">
                    {new Date(test.created_at).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DistClientBloodTestsPage;
